import { VscLoading } from 'react-icons/vsc'

function LoadSpinner() {
  return (
    <div className="flex h-full w-full">
      <VscLoading className="mx-auto my-auto animate-spin text-xl text-gray-800" />
    </div>
  )
}
export default LoadSpinner
